<template>
	<div class="organization-user-roles">
		<div class="organization-user-roles__sticky-top">
			<div class="flex ai-c jc-sb mb-sm">
				<h4 class="ma-0">Rôles</h4>
				<shared-role-flat-select
					v-if="!readonly && (setup.self.can('UserUpdate') && !userIsAgencyWatchingClient) && setup.isOrganizationUser()"
					:model-value="user?.roles"
					:user="setup.props.user">
					<o-button
						nude
						color="info"
						class="organization-user-roles__button">
						Ajouter ou supprimer un/des rôle(s)
					</o-button>
				</shared-role-flat-select>
			</div>

			<div
				v-if="user?.roles?.length"
				class="flex g-xs fw-w">
				<o-chips
					v-for="role in user.roles"
					:key="role.id"
					v-tooltip="`Cliquez pour filtrer`"
					class="organization-user-roles__chips"
					:color="setup.swapColor(role.organizationRole?.colorName)"
					:class="{ 'organization-user-roles__chips--inactive' : !setup.roleIsActive(role) }"
					outline
					@click="setup.toggleRole(role)">
					{{ role.organizationRole?.name }}
				</o-chips>
			</div>
			<o-alert
				v-else
				center
				color="info">
				Aucun rôle défini pour cet utilisateur
			</o-alert>
		</div>

		<template v-if="user?.roles?.length">
			<permission-list
				class="mt-sm"
				hide-global-toggle
				:roles-permissions="setup.userRolesPermissions"/>
		</template>
	</div>
</template>

<script setup lang="ts">
import PermissionList from '@/components/permission/PermissionList.vue';
import OrganizationUserRolesSetupService from '@/setup/organization-user/OrganizationUserRolesSetupService';
const props = defineProps(OrganizationUserRolesSetupService.props);
const setup = new OrganizationUserRolesSetupService(props);
</script>

<style scoped lang="less">
.organization-user-roles {
	&__sticky-top {
    position: sticky;
		top: -4rem;
		padding: 1rem 0;
		background-color: white;
		z-index: 10;
	}

	&__chips {
		cursor: pointer;
		opacity: 1;
		user-select: none;
		transition: opacity .3s;

		&--inactive {
			opacity: 0.3;
		}
	}
}
</style>
